import React from "react";
import { BoundedMap } from "../../lib/BoundedMap";
import masterData from "../../lib/masterData";
import { openLink } from "../../lib/Link";
import { transportationString, getAssetUrl } from "../../lib/masterUtil";
import { TYPE_PC, TYPE_SP } from "../../common/defines";

const defaultZoom = 20;

export class MapControl extends React.PureComponent {
  render() {
    return (
      <div className={this.props.isDetail ? "map_cont map_cont_detail" : "map_cont"}>
        <div ref="mapElement" className="map">
          Please set up a google map here!!!
        </div>
        {!this.props.isDetail && this.props.type === TYPE_SP &&
          <React.Fragment>
            <div className="map_footer">
              <div className="item inside">
                24時間利用可能な
                  <br />
                  屋内型トランクルーム
                </div>
              <div className="item outside">
                入出庫しやすい
                  <br />
                  屋外型トランクルーム
                </div>
            </div>
            <div className="map_footer">
              <div className="item premium">
                屋内型オリジナル設計
                  <br />
                  トランクハウス24
                  <br />
                  シリーズ
                </div>
              <div className="item motorbike">
                バイク専用物件
                  <br />
                  BOXタイプもあります
                </div>
            </div>
            <div className="map_footer">
              <div className="item with_campaign">
                キャンペーン開催中の場合
                <br />
                得アイコンがつきます
              </div>
            </div>
          </React.Fragment>
        }
        {!this.props.isDetail && this.props.type === TYPE_PC &&
          <React.Fragment>
            <div className="map_footer">
              <div className="item inside">
                24時間利用可能な
                <br />
                屋内型トランクルーム
              </div>
              <div className="item outside">
                入出庫しやすい
                <br />
                屋外型トランクルーム
              </div>
              <div className="item premium">
                屋内型オリジナル設計
                <br />
                トランクハウス24シリーズ
              </div>
              <div className="item motorbike">
                バイク専用物件
                <br />
                BOXタイプもあります
              </div>
              <div className="item with_campaign">
                キャンペーン開催中の場合
                <br />
                得アイコンがつきます
              </div>
            </div>
          </React.Fragment>
        }
      </div>
    );
  }
  componentDidMount() {
    this.boundedMap = new BoundedMap({
      target: this.props.target,
      markers: this.props.list,
      targetElement: this.refs.mapElement,
      getPosition: asset => asset.geo,
      getIcon: asset => {
        if (this.props.target && asset.assetId === this.props.target.assetId) {
          // 近くの物件リストで、基準となる物件の場合は、デフォルトアイコンにする。
          return null;
        } else {
          const assetIcon = masterData.assetIcon.bySlug[asset.assetIcon];
          return assetIcon && assetIcon.icon
        }
      },
      getParam: asset => {
        if (this.props.target && asset.assetId === this.props.target.assetId) {
          return { zIndex: 1000 }
        }
      },
      infoWindow: asset => `<div style="cursor: pointer"><p class="left">${
        asset.name
        }</p>
        <p class="left">${asset.address}</p>
        <p class="left">${asset.stations &&
        asset.stations
          .map(stationInfo => transportationString(stationInfo))
          .join("<br>")}</p></div>`,
      onInfoWindowClicked: asset => {
        openLink(this.props.history, {
          to: getAssetUrl(asset),
        });
      },
      zoom: this.props.list.length >= 2 ? null : defaultZoom,
    });
  }
  componentDidUpdate(prevProps, prevState) {
    this.boundedMap.setMarkers(this.props.list);
  }
}



// WEBPACK FOOTER //
// ./pages/area/MapControl.jsx